const plugin = {
  install: (Vue, options) => {
    const KBManager = {
      dismiss () {
        // console.log('键盘消失')
        // 微信内，页面被键盘弹起后，
        // 不会复原，这里复原一下
        let currentPosition, timer;
        let speed = 1; //页面滚动距离
        timer = setInterval(function() {
          currentPosition =
            document.documentElement.scrollTop || document.body.scrollTop;
          currentPosition -= speed;
          window.scrollTo(0, currentPosition); //页面向上滚动
          currentPosition += speed;
          window.scrollTo(0, currentPosition); //页面向下滚动
          clearInterval(timer);
        }, 1);
      },
      blurKB() {
        console.log('blurKB')
        Vue.prototype.$nextTick(() => {
          const inputs = document.querySelectorAll('input')
          const textareas = document.querySelectorAll('textarea')
          inputs.forEach(element => {
            // console.log('element input',element)
            element.blur()
          });
          textareas.forEach(element => {
            // console.log('element element',element)
            element.blur()
          });
        })
      }
    }

    // 添加到全局
    window.$kbmanager = Vue.$kbmanager = KBManager
    // 添加到实例
    Vue.prototype.$kbmanager = KBManager

    document.body.addEventListener('focus', (event) => {
      let target = event.target
      
      if (target.className == 'weui-input'
       || target.className == 'weui-textarea'
       || target.localName == 'input'
       || target.localName == 'textarea') {
        let handler = function () {
          target.removeEventListener('blur', handler);
          KBManager.dismiss()
        }
        target.addEventListener('blur', handler);
      }

      // console.log('focus',target.className,target)

    }, true)

  }
}

export default plugin



// WEBPACK FOOTER //
// ./src/plugins/KBManager.js